import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import Box from "@mui/material/Box";

export const SignatureCanvas = forwardRef((props, ref) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [context, setContext] = useState(null);

  useImperativeHandle(ref, () => ({
    clear: () => {
      if (context && canvasRef.current) {
        context.clearRect(
          0,
          0,
          canvasRef.current.width,
          canvasRef.current.height
        );
        if (props.onEndDrawing) props.onEndDrawing();
      }
    },
    getSignature: () => {
      if (canvasRef.current) {
        const blank = document.createElement("canvas");
        blank.width = canvasRef.current.width;
        blank.height = canvasRef.current.height;
        if (canvasRef.current.toDataURL() === blank.toDataURL()) {
          return null;
        }
        return canvasRef.current.toDataURL("image/png");
      }
      return null;
    },
    loadImage: (dataURL) => {
      if (!dataURL || !canvasRef.current) return;
      const canvas = canvasRef.current; // রেফারেন্সটি একটি ভেরিয়েবলে রাখুন
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        // এখানে চেক করা হচ্ছে ক্যানভাসটি এখনও ডমে আছে কি না
        if (canvas && canvas.width) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }
      };
      img.src = dataURL;
    },
  }));

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.lineCap = "round";
    ctx.strokeStyle = "#000000";
    ctx.lineWidth = 2;
    setContext(ctx);

    const resizeCanvas = () => {
      const parent = canvas.parentElement;
      if (parent && canvas) {
        // রিসাইজ করার সময় কন্টেন্ট যেন মুছে না যায় তার জন্য ব্যাকআপ রাখা যেতে পারে
        // তবে সিম্পল রাখার জন্য শুধু উইডথ/হাইট সেট করছি
        canvas.width = parent.offsetWidth;
        canvas.height = parent.offsetHeight;
        ctx.lineCap = "round";
        ctx.strokeStyle = "#000000";
        ctx.lineWidth = 2;
      }
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);
    return () => window.removeEventListener("resize", resizeCanvas);
  }, []); // ডিপেন্ডেন্সি অ্যারে খালি রাখা হয়েছে যাতে বারবার রান না হয়

  const getCoordinates = (event) => {
    if (!canvasRef.current) return { x: 0, y: 0 };
    const rect = canvasRef.current.getBoundingClientRect();
    if (event.touches && event.touches.length > 0) {
      return {
        x: event.touches[0].clientX - rect.left,
        y: event.touches[0].clientY - rect.top,
      };
    }
    return { x: event.clientX - rect.left, y: event.clientY - rect.top };
  };

  const startDrawing = (event) => {
    event.preventDefault();
    const { x, y } = getCoordinates(event);
    if (context) {
      context.beginPath();
      context.moveTo(x, y);
      setIsDrawing(true);
    }
  };

  const stopDrawing = (event) => {
    if (isDrawing && context) {
      context.closePath();
      setIsDrawing(false);
      if (props.onEndDrawing) props.onEndDrawing();
    }
  };

  const draw = (event) => {
    if (!isDrawing || !context) return;
    const { x, y } = getCoordinates(event);
    context.lineTo(x, y);
    context.stroke();
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: 150,
        bgcolor: "#f8fafc",
        border: "1px dashed",
        borderColor: "#cbd5e1",
        borderRadius: "12px",
        overflow: "hidden",
        touchAction: "none",
      }}
    >
      <canvas
        ref={canvasRef}
        style={{ width: "100%", height: "100%", cursor: "crosshair", display: 'block' }}
        onMouseDown={startDrawing}
        onMouseUp={stopDrawing}
        onMouseMove={draw}
        onMouseLeave={stopDrawing}
        onTouchStart={startDrawing}
        onTouchEnd={stopDrawing}
        onTouchMove={draw}
      />
    </Box>
  );
});